export const CONFIRM_USER_AUDIT = 'audit/CONFIRM_USER_AUDIT';
export const CONFIRM_USER_AUDIT_SUCCESS = 'audit/CONFIRM_USER_AUDIT_SUCCESS';
export const CONFIRM_USER_AUDIT_ERROR = 'audit/CONFIRM_USER_AUDIT_ERROR';

export const FETCH_PENDING_ROLE_IDS = 'audit/FETCH_PENDING_ROLE_IDS';
export const FETCH_PENDING_ROLE_IDS_SUCCESS = 'audit/FETCH_PENDING_ROLE_IDS_SUCCESS';
export const FETCH_PENDING_ROLE_IDS_ERROR = 'audit/FETCH_PENDING_ROLE_IDS_ERROR';

export const CONFIRM_ROLE_AUDIT = 'audit/CONFIRM_ROLE_AUDIT';
export const CONFIRM_ROLE_AUDIT_SUCCESS = 'audit/CONFIRM_ROLE_AUDIT_SUCCESS';
export const CONFIRM_ROLE_AUDIT_ERROR = 'audit/CONFIRM_ROLE_AUDIT_ERROR';
